export enum TemplateDataField {
	// Customer Properties - Personal Info
	PersonalPrefix = 43,
	PersonalPhoneNumber = 44,
	PersonalFirstName = 45,
	PersonalLastName = 47,
	PersonalEmail = 48,
	PersonalSSN = 53,
	PersonalMiddleName = 543,
	PersonalSuffix = 2208,
	PersonalStreetAddress = 57,
	PersonalStreetAddress2 = 59,
	PersonalCity = 61,
	PersonalState = 58,
	PersonalZipCode = 60,
	PersonalCountry = 1911,
	PersonalSigningCapacity = 3557,
	PersonalParentProfitEntity = 3560,
	CitizenshipStatus = 2184,
	PersonalPreferredName = 3387,
	PersonalDateOfBirth = 546,
	// contact info
	PhoneNumber = 3388,
	PersonalMailingStreetAddress = 63,
	PersonalMailingStreetAddress2 = 64,
	PersonalMailingCity = 65,
	PersonalMailingState = 66,
	PersonalMailingZipCode = 67,

	// Customer Properties - Business Info
	BusinessName = 2,
	BusinessPhone = 9,
	BusinessAddress1 = 17,
	BusinessState = 18,
	BusinessAddress2 = 19,
	BusinessZipCode = 20,
	BusinessCity = 21,
	BusinessIndustryCode = 10,
	BusinessSubEntityType = 2339,
	BusinessSigningCapacity = 3558,
	BusinessParentProfitEntity = 3561,
	BusinessEmail = 13,
	FranchiseDataFranchiseName = 2352,
	MailingAddressDifferent = 3117,
	DidBusinessExceed5Million = 3520,
	GrossAnnualRevenue = 3525,
	BorrowerAddressType = 3528,
	BusinessMailingStreetAddress = 24,
	BusinessMailingStreetAddress2 = 25,
	BusinessMailingCity = 26,
	BusinessMailingState = 27,
	BusinessMailingZipCode = 28,

	// Customer Properties - Farm Info
	FarmName = 1021,
	FarmAddress1 = 1022,
	FarmAddress2 = 1023,
	FarmCity = 1029,
	FarmState = 1047,
	FarmEmail = 1035,
	FarmZipCode = 1050,
	FarmIndustryCode = 1037,
	FarmSigningCapacity = 3559,
	FarmParentProfitEntity = 3562,
	FarmMailingStreetAddress = 1040,
	FarmMailingStreetAddress2 = 1041,
	FarmMailingCity = 1042,
	FarmMailingState = 1043,
	FarmMailingZipCode = 1044,

	// Customer Properties - Collateral Info
	CollateralDescription = 442,
	CollateralType = 443,
	CollateralPledgedBy = 444,

	// Vehicle Properties - Collateral Info
	VehicleState = 3229,
	VehicleMake = 460,
	VehicleModel = 461,
	VehicleYear = 463,
	VehicleBodyStyle = 464,

	// Customer Properties - Nonprofit Info
	NonprofitName = 2,
	NonprofitPhone = 9,
	NonprofitState = 18,
	NonprofitSectorCode = 10,

	// Proposed Loan
	ProposedLoanLoanAmount = 127,
	ProductCode = 152,
	LoanTypeCode = 153,
	PurposeCode = 154,
	CallCode = 150,
	CollateralCode = 151,

	// BeneficialOwner
	BeneficialOwnerPercent = 3143,
	BeneficialOwnerDateUpdated = 3144,
	BeneficialOwnerRoleType = 3145,
	BeneficialOwnerCompanyCustomerId = 3167,
	BeneficialOwnerOwnerCustomerId = 3168,
	BeneficialOwnerOwnershipStartDate = 3768,

	// FinancialSubaccounts
	SubaccountName = 3106,
	SubaccountValue = 3107,
	SubaccountCustomer = 3111,
	SubaccountFinancialDataId = 3110,
	SubaccountFinancialStatement = 3109,
	SubaccountParentField = 3108,

	// Personal Financial Statements
	PfsCustomer = 1215,
	PfsPeriodEndDate = 1319,

	// Proposed Products
	ProposedProductDropdown = 3102,

	// Real Estate Financials
	RealEstatePropertyId = 1506,
	RealEstatePropertyName = 1507,
	RealEstatePropertyType = 1508,
	RealEstatePropertyValue = 1529,
	RealEstatePropertyOwnership = 1553,
	RealEstateOwnerFinancialDataId = 3339,

	// Business Investments
	BusinessInvestmentOwnerCustomerId = 3335,
	BusinessInvestmentOwnerFinancialDataId = 3336,
	BusinessInvestmentInvestmentEntityId = 3337,
	BusinessInvestmentValue = 3338,

	// HMDA
	HmdaLoanPurpose = 2381,

	// Race / Demographic Fields
	PersonalRace = 1738,
	OwnershipRace = 2130
}
